import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function PreHeader() {
  return <div className="bg-brand-brown text-brand-cream py-2.5 px-4 text-center" data-id="element-108">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base" data-id="element-109">
        <ShieldCheckIcon className="w-4 h-4 text-brand-gold shrink-0" data-id="element-110" />
        <span data-id="element-111">
          Compra 100% segura • Descarga instantánea • Satisfacción garantizada
        </span>
      </div>
    </div>;
}